<template>
  <div class="mod-pointsgetlog">
    <el-form
      :inline="true"
      :model="searchForm"
      @keyup.enter.native="getDataList(1)"
    >
      <el-form-item>
        <el-input
          v-model="searchForm.userName"
          placeholder="员工名"
          clearable
        />
      </el-form-item>

      <el-form-item>
        <el-select
          v-model="searchForm.pointsWay"
          clearable
          placeholder="获取渠道"
        >
          <el-option key="0" label="提前订餐" value="0" />
          <el-option key="1" label="按日超额支付" value="1" />
          <el-option key="2" label="按月超额支付" value="2" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button @click="getDataList(1)">查询</el-button>
        <el-button
          v-if="isAuth('tc:pointsgetlog:save')"
          type="primary"
          @click="addOrUpdateHandle()"
          >新增</el-button
        >
        <el-button
          v-if="isAuth('tc:pointsgetlog:delete')"
          type="danger"
          @click="deleteHandle()"
          :disabled="dataListSelections.length <= 0"
          >批量删除</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      :data="dataList"
      border
      @selection-change="selectionChangeHandle"
      style="width: 100%"
    >
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50"
      >
      </el-table-column>

      <el-table-column
        width="200"
        prop="userName"
        header-align="center"
        align="center"
        label="员工名"
      >
      </el-table-column>

      <el-table-column
        prop="pointsWay"
        header-align="center"
        align="center"
        label="获取渠道"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.pointsWay === 0" size="small" type="success">
            提前订餐
          </el-tag>
          <el-tag
            v-else-if="scope.row.pointsWay === 1"
            size="small"
            type="danger"
          >
            按日超额支付
          </el-tag>
          <el-tag
            v-else-if="scope.row.pointsWay === 2"
            size="small"
            type="danger"
          >
            按月超额支付
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="playMoney"
        header-align="center"
        align="center"
        label="花费金额"
      >
      </el-table-column>
      <el-table-column
        prop="pointsTime"
        header-align="center"
        align="center"
        label="获取积分时间"
      >
      </el-table-column>
      <el-table-column
        prop="points"
        header-align="center"
        align="center"
        label="积分量"
      >
      </el-table-column>
      <!--      <el-table-column-->
      <!--        fixed="right"-->
      <!--        header-align="center"-->
      <!--        align="center"-->
      <!--        width="150"-->
      <!--        label="操作">-->
      <!--        <template slot-scope="scope">-->
      <!--&lt;!&ndash;          <el-button v-if="isAuth('tc:pointsgetlog:info')" type="text" size="small" @click="showDetails(scope.row.id)">查看</el-button>&ndash;&gt;-->
      <!--          <el-button v-if="isAuth('tc:pointsgetlog:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改</el-button>-->
      <!--          <el-button v-if="isAuth('tc:pointsgetlog:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './pointsgetlog-add-or-update';

export default {
  data() {
    return {
      searchForm: {
        userName: '',
        pointsWay: '',
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListSelections: [],
      addOrUpdateVisible: false,
    };
  },
  components: {
    AddOrUpdate,
  },
  activated() {
    this.getDataList(1);
  },
  methods: {
    // 获取数据列表
    getDataList(page) {
      this.$http({
        url: '/tc/pointsgetlog/list',
        method: 'get',
        params: {
          page: page ? page : this.pageIndex,
          limit: this.pageSize,
          userName: this.searchForm.userName,
          pointsWay: this.searchForm.pointsWay,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.records;
          this.totalPage = data.page.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 查看详情
    showDetails(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, true);
      });
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(id) {
      let ids = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.id;
          });
      this.$confirm(`确定对[id=${ids.join(',')}]进行[删除]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http({
            url: '/tc/pointsgetlog/delete',
            method: 'post',
            data: ids,
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
              });
              this.getDataList();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
